import type { JobModuleTriggerCardProps } from "./job-module-trigger-card.type";

import { Card } from "antd";

import JobModuleCreateButton from "@/modules/job-module/job-module-create-button";

import JobModuleTriggerCardTitle from "./job-module-trigger-card-title";
import "./job-module-trigger-card.style.less";

const JobModuleTriggerCard = ({
  module,
  subjectType,
  subjectIds,
  loading,
}: JobModuleTriggerCardProps) => {
  return (
    <Card
      size="small"
      title={<JobModuleTriggerCardTitle module={module} />}
      className="job-module-trigger-card"
    >
      <JobModuleCreateButton
        module={module}
        subjectType={subjectType}
        subjectIds={subjectIds}
        loading={loading}
      />
    </Card>
  );
};

export default JobModuleTriggerCard;
